import { addDays, format } from "date-fns";
import { useEffect, useState } from "react";
import { API_GATEWAY_ENDPOINT } from "../../../../constants/api";

export function useGetHorasMaquinaRangoFechas(idMaquina, fechaInicio, fechaFinal, idMina, refreshKey) {
  const [horas, setHoras] = useState([]);
  const [loadingHoras, setLoadingHoras] = useState(false);
  const [errorHoras, setErrorHoras] = useState(null);

  useEffect(() => {
    const getHorasMaquina = async () => {
      setLoadingHoras(true);
      setErrorHoras(null);

      const adjustedFinalDate = format(addDays(new Date(`${fechaFinal}T00:00:00`), 1), "yyyy-MM-dd");

      try {
        const response = await fetch(
          API_GATEWAY_ENDPOINT+"jumbo/get-horas-maquina-turno-rango-fecha",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": `${process.env.REACT_APP_API_KEY}`
            },
            body: JSON.stringify({
              idMaquina: idMaquina,
              fechaInicio: `${fechaInicio} 07:00:00`,
              fechaFinal: `${adjustedFinalDate} 07:00:00`, 
              idMina: idMina
            })
          }
        );

        const { data, message, status } = await response.json();

        if (status === "success") {
          setHoras(data);
        }

        if (status === "error") {
          setErrorHoras(message);
        }
      } catch (error) {
        setErrorHoras(error.message);
      } finally {
        setLoadingHoras(false);
      }

    };

    getHorasMaquina();
  }, [idMaquina, fechaInicio, fechaFinal, idMina, refreshKey]);

  return {
    horas,
    loadingHoras,
    errorHoras
  };
}
